var React = require( 'react' );
var createReactClass = require('create-react-class');
var TopicList = require('./topicList.jsx');

var ContentListItem = createReactClass({

    render: function(){
        return (
            <li>
                <h3>{this.props.content.title}</h3>
                {this.props.content.description &&
                    <p>{this.props.content.description}</p>
                }
                {this.props.content.topics.length > 0 &&
                    <TopicList topicList={this.props.content.topics} />
                }
            </li>
        );
    }
});

module.exports = ContentListItem;



// WEBPACK FOOTER //
// ./src/common/routes/faqs/components/layout/contentListItem.jsx